import { TimesheetLinesByDate, TimesheetLinesByWeek } from '../../../domain/timesheets-domain';
import dayjs from 'dayjs';

// creates an array of group timesheet lines by week
export function groupTimesheetLinesByWeek(timesheetLines: TimesheetLinesByDate[]) {
  return timesheetLines.reduce((timesheetLineWeekAccumulator: TimesheetLinesByWeek[], currentValue) => {
    const parsedDate = dayjs(currentValue.date, 'YYYY-MM-DD').startOf('day');
    const startDateOfWeek = parsedDate.startOf('week').format('YYYY-MM-DD');
    const endDateOfWeek = parsedDate.endOf('week').format('YYYY-MM-DD');
    const isSameWeek = timesheetLineWeekAccumulator.find((timesheetWeek) => timesheetWeek.startDateOfWeek === startDateOfWeek && timesheetWeek.endDateOfWeek === endDateOfWeek);

    if (isSameWeek)
      return timesheetLineWeekAccumulator.map((timesheetWeek) => {
        if (timesheetWeek.startDateOfWeek === startDateOfWeek && timesheetWeek.endDateOfWeek === endDateOfWeek) {
          return { ...timesheetWeek, totalHours: timesheetWeek.totalHours + currentValue.totalHours, timesheetLinesByDay: [...timesheetWeek.timesheetLinesByDay, currentValue] };
        }

        return timesheetWeek;
      });

    return [...timesheetLineWeekAccumulator, { startDateOfWeek: startDateOfWeek, endDateOfWeek: endDateOfWeek, totalHours: currentValue.totalHours, timesheetLinesByDay: [currentValue] }];
  }, []);
}
